import { useParams } from "react-router-dom";
import MainLayout from "src/layouts/MainLayout";
import { LeftPane } from "./LeftPane";
import { RightPane } from "./RightPane";
import { Container } from "./ApplicationDetailPage.styles";
import { Header } from "./Header";
import { ApplicationProvider } from "./ApplicationContext";
import { usePageView } from "src/hooks/usePageView";
import Banner from "./Banner";
import PreApprovalBanner from "./PreApprovalBanner";
import SubmissionFailedBanner from "./SubmissionFailedBanner";

interface Props {
  section: string;
}

export default ({ section }: Props) => {
  const { application_id } = useParams();
  usePageView("Application Details");

  return (
    <ApplicationProvider application_id={application_id}>
      <MainLayout page="application-details" showHeading={false}>
        <Header />
        <Banner />
        <PreApprovalBanner />
        <SubmissionFailedBanner />
        <Container>
          <LeftPane currentSection={section} />
          <RightPane currentSection={section} />
        </Container>
      </MainLayout>
    </ApplicationProvider>
  );
};
